import axios from "axios";
import { apiUrl } from "../constant";

const PNL_REPORT_BASE = `${apiUrl}/api/reports/pnl`;

export const getPnlMonthlySummaryService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/monthly-summary`, data);
};

export const getPnlRowDetailService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/row-detail`, data);
};

export const getPnlRowDetailSellersService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/row-detail/sellers`, data);
};

export const refreshPnlService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/admin/refresh`, data);
};

export const closeShippingLabelsService = (data) => {
    return axios.post(`${PNL_REPORT_BASE}/admin/close-shipping-labels`, data);
};
